__turbopack_context__.v({
  "link": "Navbar-module-scss-module__riO0sG__link",
  "menu": "Navbar-module-scss-module__riO0sG__menu",
  "menuContent": "Navbar-module-scss-module__riO0sG__menuContent",
  "navContainer": "Navbar-module-scss-module__riO0sG__navContainer",
  "opened": "Navbar-module-scss-module__riO0sG__opened",
  "selected": "Navbar-module-scss-module__riO0sG__selected",
});
